<template>
  <div
      v-loading="loading"
      element-loading-text="加载中..."
      style="background-color: #F0F2F5;border-radius: 20px;display: flex;min-width: 1600px"
  >
    <div style="width: 70%;margin:14px 6px;min-width: 400px">
      <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
        <div class="el-icon-back" style="margin-left: 10px;font-size: 18px;font-weight: bold"
             @click="$router.back()"></div>
        <div style="font-weight: bold;text-align: center;font-size: 15px">{{ form.formName }}</div>
        <div></div>
      </div>
      <div style="height: 77vh;overflow: auto;">
        <form-render
            style="height: 100%"
            class="process-form"
            mode="PC"
            ref="form"
            :forms="forms"
            v-model="formData"
        />
      </div>
    </div>
    <div style="width: 30%;">
      <div class="approver">
        <audit-flow ref="approver"/>
      </div>
      <process-form ref="process" class="function" :processInfo="processInfo" :type="type"></process-form>
    </div>
  </div>
</template>

<script>
import {getProcessInstanceInfo} from "@/api/design";
import FormRender from "@/views/common/form/FormRender";
import {flatFormItem} from "../form";
import AuditFlow from "../auditFlow/AuditFlow";
import ProcessForm from "/src/views/workspace/process/ProcessForm";

export default {
  components: {AuditFlow, FormRender, ProcessForm},
  data() {
    return {
      processInstanceId: "",
      taskId: "",
      form: {
        formName: ""
      },
      formData: {},
      currentNode: {},
      processInfo: "",
      cc: [],
      // 整页加载态：进入页面即开始请求流程详情
      loading: true
    };
  },
  computed: {
    forms() {
      return this.$store.state.design.formItems;
    },
    type() {
      return this.$route.query.type;
    },
  },
  methods: {
    getProcessInfo() {
      getProcessInstanceInfo(this.processInstanceId, this.taskId).then((rsp) => {
        this.$refs.process.state = rsp.data.result.state;
        const form = {...rsp.data.result.processTemplates};
        const currentNode = {...rsp.data.result?.currentNode};
        const formData = {...rsp.data.result.formData};
        form.logo = JSON.parse(form.logo);
        form.settings = JSON.parse(form.settings);
        form.process = JSON.parse(form.process);
        // const perms = currentNode?.props?.formPerms || [];
        // 表单项 从json转换为数组 用于渲染表单 扁平化处理 去除了spanLayout
        const formItems = flatFormItem(JSON.parse(form.formItems));
        // item显示状态映射关系
        // const itemStatusMap = new Map(perms.map((it) => [it.id, it.perm]));
        const items = formItems.map((item) => {
          // perm说明 只读R  编辑E  隐藏H
          // const perm = itemStatusMap.get(item.id);
          //暂时先全部只读--- 后续在尝试节点的判断
          item.props.readerMode = true;
          return item;
          // if (perm === "E") {
          //   return item;
          // } else if (perm === "R") {
          //
          //   return item;
          // } else if (perm === "H") {
          //   return undefined;
          // }
        }).filter(Boolean);

        form.formItems = items;
        this.$store.state.design = form;
        this.$store.state.endList = rsp.data.result.endList;
        this.$store.state.runningList = rsp.data.result.runningList;
        this.$store.state.noTakeList = rsp.data.result.noTakeList;
        this.$store.state.detailVOList = rsp.data.result.detailVOList;
        this.$store.state.auditList = rsp.data.result.auditList;
        this.currentNode = currentNode;
        this.formData = formData;
        this.processInfo.formData = formData;
        this.processInfo.signFlag = rsp.data.result.signFlag;
        this.processInfo.currentNode = currentNode;
        this.form = form;
        console.log(form)
        this.$refs.approver.startProcess(form.process, rsp.data.result, this.processInstanceId);
      }).catch(() => {
        this.$message.error("流程信息加载失败，请稍后重试");
      }).finally(() => {
        this.loading = false;
      })
    },
  },
  beforeMount() {
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    const str = localStorage.getItem("user");
    const currentUserInfo = JSON.parse(str);
    currentUserInfo.id = currentUserInfo.id.toString();
    this.processInfo = {
      processInstanceId: this.processInstanceId,
      taskId: this.taskId,
      signFlag: null,
      currentNode: {},
      currentUserInfo: currentUserInfo,
    };
  },
  mounted() {
    this.getProcessInfo();
  },
};
</script>

<style lang="less" scoped>

.process-view {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &__header {
    margin-bottom: 10px;
  }

  &__tabs {
    flex: 1;

    /deep/ .el-tabs__content {
      height: calc(100vh - 150px);
      overflow-y: auto;
    }
  }
}

.approver {
  padding: 10px;
  background-color: white;
  border-radius: 14px;
  margin: 16px 14px;
}

.function {
  border-radius: 15px;
  margin: 16px 40px;
  background-color: rgba(255, 255, 255, 1);
}
</style>
